import React from "react"
import * as style from "./style.module.css"
import ArticleList from "/src/components/ArticleList"
import Layout from "/src/components/Layout"
import MainButton from "/src/components/MainButton"
import Seo from "/src/components/Seo"
import { getPathFromTemplateType } from "/src/utils/getPathFromTemplateType"
import { Parallax } from "react-scroll-parallax";
import { Link } from "gatsby";
import CommonTitle from "/src/components/CommonTitle/index.jsx";
import Keyvisual from "/src/components/Keyvisual/index.jsx";
import FadeIn from "/src/components/FadeIn/index.jsx";
import PalaImg1 from "/src/images/top/pala-1.jpg";
import PalaImg2 from "/src/images/top/pala-3.jpg";
import PalaImg3 from "/src/images/top/pala-2.jpg";

import ServiceImg1 from "../../images/top/service-1.jpg";
import ServiceImg2 from "../../images/top/service-2.jpg";
import ServiceImg3 from "../../images/top/service-3.jpg";

import BottomImg1 from "../../images/top/bottom-1.png";
import BottomImg2 from "../../images/top/bottom-2.png";
import BottomImg3 from "../../images/top/bottom-3.png";
import BottomImg4 from "../../images/top/bottom-4.png";

import LinkImg1 from "../../images/top/service-1.jpg";
import LinkImg2 from "../../images/top/service-2.jpg";

const Page = ({ pageContext }) => {
    const Group = {
      PallaxImages: [
        {
          image: PalaImg1,
          speed: -15,
        },
        {
          image: PalaImg2,
          speed: -5,
        },
        {
          image: PalaImg3,
          speed: -24,
        },
      ],
      serviceBox: [
        {
          image: ServiceImg1,
          title: "地域との絆を大切に",
          detail: "私たちは、地域の皆様お一人おひとりの暮らしに心を込めて寄り添い、<br />"+
          "それぞれの生活スタイルやお気持ちに合わせて、きめ細やかなサービスをご提供しています。<br />"+
          "日々の暮らしのお手伝いから医療的なケアまで、温かな笑顔と優しい言葉かけを大切に、ゆっくりとしたペースで丁寧にサポートさせていただきます。",
          link: "/",
        },
        {
          image: ServiceImg2,
          title: "利用者中心のサービス",
          detail: "私たちは、利用者様お一人おひとりの大切なご要望やお困りごとに合わせて、<br />"+
          "柔軟できめ細やかなサービスをご提供させていただいております。<br />"+
          "医療的なケアはもちろんのこと、日々の暮らしのお手伝いや通院の付き添いまで、幅広いサービスメニューを取り揃えておりますので、どうぞご安心ください。<br />"+
          "また、お時間についても利用者様やご家族様のライフスタイルに合わせて柔軟に調整させていただくことが可能です。",
          link: "/",
        },
        {
          image: ServiceImg3,
          title: "安心と笑顔の提供",
          detail: "私たちの訪問介護士は、利用者様一人ひとりの生活や想いに心を込めて寄り添い、温かな笑顔と優しい言葉かけを大切にしながら、きめ細やかなサービスを提供させていただいております。<br />"+
          "スタッフ一同、介護の専門家としての知識や技術の向上に日々努めるとともに、この介護士さんでよかった」と思っていただけるような、心のこもった対応を心がけています。<br />"+
          "また、当事業所は介護士の働きやすい職場環境づくりに力を入れており、多くのスタッフが長く勤めていることで、<br />"+
          "利用者様やご家族様との深い信頼関係を築くことができております。",
          link: "/",
        },
      ], 
      serviceBottom: [
        {
          text: "医療的なケアが受けられる",
          image: BottomImg1,
        },
        {
          text: "自費サービスが豊富<br />"+
                "深夜対応も可能２０時～受付可",
          image: BottomImg2,
        },
        {
          text: "利用者都合で柔軟に時間調整<br />"+
                "（１時間利用多め、長くて６時間）",
          image: BottomImg3,
        },
        {
          text: "生活援助・身体介護<br />通院の待ち時間",
          image: BottomImg4,
        },

      ],

    } 
    
  

  return (
    <Layout>
      <Keyvisual />
      <section className={style.features_section}>
        <CommonTitle title={"Features"} subTitle={"訪問介護えびすの特徴"}/>
        <div className={style.pallax_group}>
          {Group.PallaxImages.map((palaItem, palaIndex) => {
            return (
              <Parallax key={palaIndex} speed={palaItem.speed} className={style.pallax_box}>
                <div>
                  <figure>
                    <img src={palaItem.image} alt={"画像"} />
                  </figure>
                </div>
              </Parallax>
            )
          })}
          <p className={style.textbox}>
            <span>
            私たちは、地域の皆様に寄り添い、<br/>
            一人ひとりのニーズに合わせた柔軟な<br/>
            サービスを提供しています。<br/>
            医療的ケアから生活支援まで、経験豊富なスタッフが24時間体制で対応し、利用者様とご家族様に安心と笑顔を<br/>
            お届けいたします。<br/>
            多職種連携による質の高いケアと、きめ細やかな生活サポートを通じて、住み慣れた地域での暮らしを支えてまいります。
            </span>
          </p>
        </div>
      </section>
      <ul className={style.service_bottom_group}>
          {Group.serviceBottom.map((bottomItem, bottomIndex) => {
            return (
              <FadeIn key={bottomIndex}>
                <li className={style.service_bottom_box}>
                  <figure>
                    <img src={bottomItem.image} alt={`${bottomItem.text}の画像`} />
                    <p dangerouslySetInnerHTML={{ __html: bottomItem.text }}></p>
                  </figure>
                </li>
              </FadeIn>
            )
          })}
        </ul>

      <section className={style.service_section}>
        <CommonTitle title={"Service"} subTitle={"サービスの内容"}/>
        <p className={style.service_section_heading}>ご家族様の想いにも寄り添いながら、皆様が安心して心地よく過ごせるよう、<br/>
        私たちスタッフ一同が真心を込めてお手伝いをさせていただいております。</p>
        <div className="content">
          <div className={style.service_group}>
            {Group.serviceBox.map((serviceItem, serviceIndex) => {
              return (
                <div className={style.service_box} key={serviceIndex}>
                  <figure>
                    <img src={serviceItem.image} alt={`${serviceItem.title}の画像`} />
                  </figure>
                  <div className={style.service_textbox}>
                    <h4>{serviceItem.title}</h4>
                    <p dangerouslySetInnerHTML={{ __html: serviceItem.detail }}></p>
                    <div className={style.link}>
                      <Link to={serviceItem.link}><p>more</p></Link>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
        {/* <ul className={style.service_bottom_group}>
          {Group.serviceBottom.map((bottomItem, bottomIndex) => {
            return (
              <FadeIn key={bottomIndex}>
                <li className={style.service_bottom_box}>
                  <figure>
                    <img src={bottomItem.image} alt={`${bottomItem.text}の画像`} />
                    <p dangerouslySetInnerHTML={{ __html: bottomItem.text }}></p>
                  </figure>
                </li>
              </FadeIn>
            )
          })}
        </ul> */}
        <div className={"content"}>
          <div className={style.contact_box}>
            <Link to={"/contact"}>
              <p>お問い合わせはこちら</p>
            </Link>
          </div>
        </div>
      </section>
      <section className={style.top_link_section}>
        <div className={style.top_link_group}>
          <div className={style.top_link_box}>
            <Link to={"/staff"}>
              <div>
                <img src={LinkImg1} alt={"スタッフ紹介の画像"} />
                <p>スタッフ紹介</p>
              </div>
            </Link>
          </div>
          <div className={style.top_link_box}>
            <Link to={"/voice"}>
              <div>
                <img src={LinkImg2} alt={"お客様の声の画像"} />
                <p>お客様の声</p>
              </div>
            </Link>
          </div>

        </div>
      </section>
      <section className={style.blogSec}>
        <div className={"content"}>
          <div className={style.section_description}>
            <CommonTitle title={"News"} subTitle={"お知らせ"}/>
          </div>
          {pageContext.articles.length !== 0 ? (
            <>
              <div className={style.blog_items}>
                <ArticleList articles={pageContext.articles} />
              </div>
              <div className={style.more_btn}>
                <MainButton link={getPathFromTemplateType(4)} text={"more"} />
              </div>
            </>
          ) : (
            <div className={style.blog_textarea_empty}>
              <p>現在、記事は投稿されていません。</p>
            </div>
          )}
        </div>
      </section>
      
    </Layout>
  )
}

export default Page

export const Head = ({ pageContext }) => {
  return <Seo pageContext={pageContext} />
}
